// extracted by mini-css-extract-plugin
module.exports = {"pencils":"colorpicker_pencils__365nS","styleActive":"colorpicker_styleActive__3s9n2","styleInactive":"colorpicker_styleInactive__o1X4i"};